import React from 'react'
import PropTypes from 'prop-types'

function BoundedArea({ id, color, from, isBelow, min, max }) {
  return (
    <>
      {/* Define mask */}
      <defs>
        <mask id={`${id}-mask`}>
          {/* Define visible parts of the bounded area */}
          {max && <use href={`#${max}-below`} fill="white" />}
          {min && <use href={`#${min}-above`} fill="white" />}

          {/* Define hidden parts of the bounded area */}
          {max && <use href={`#${max}-above`} fill="black" />}
          {min && <use href={`#${min}-below`} fill="black" />}
        </mask>
      </defs>

      <use href={`#${from}-${isBelow ? 'below' : 'above'}`} mask={`url(#${id}-mask)`} fill={color} opacity={0.5} />
    </>
  )
}

BoundedArea.propTypes = {
  from: PropTypes.string,
  isBelow: PropTypes.bool,
  min: PropTypes.string,
  max: PropTypes.string,
  color: PropTypes.string,
  id: PropTypes.string,
}

export default React.memo(BoundedArea)
